import { DateTime } from 'luxon';
import { getConfig } from './config';
import { parseDate, parseISODate, parseNumber } from './parse';
import _ from 'lodash';

function _convertToLuxonDate (date)
{
  let dtDate = null;
  if (date instanceof Date)
  {
    dtDate = DateTime.fromJSDate(date);
  }
  else if (typeof date === 'string') // do not use instanceof here - doesn't work consistently with strings
  {
    dtDate = parseDate(date);
    if (dtDate === null)
    {
      dtDate = parseISODate(date);
    }
  }
  else if (date instanceof DateTime)
  {
    dtDate = date;
  }

  return dtDate;
}

function _formatDate (date, pattern)
{
  let result = null;
  let dtDate = _convertToLuxonDate(date);
  if (dtDate instanceof DateTime)
  {
    result = dtDate.toFormat(pattern);
  }

  return result;
}

function _formatNumber (value)
{
  let working = value;
  if (typeof value === 'string')
  {
    working = parseNumber(value);
  }

  let result = value;
  if (typeof working === 'number')
  {
    let formatter = new Intl.NumberFormat(getConfig('locale'), {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
    result = formatter.format(working);
  }

  return result;
}

function _formatDecimal (value)
{
  let working = value;
  if (typeof value === 'string')
  {
    working = parseNumber(value);
  }

  let result = value;
  if (typeof working === 'number')
  {
    let formatter = new Intl.NumberFormat(getConfig('locale'), {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    result = formatter.format(working);
  }

  return result;
}

function _formatCurrency (value)
{
  let result = value;
  let decimal = _formatDecimal(value);
  if (!_.isNil(decimal))
  {
    let format = getConfig('format.currency');
    result = format.replace('{N}', decimal);
  }

  return result;
}

function _formatPercent (value)
{
  let result = value;
  let decimal = _formatDecimal(value);
  if (!_.isNil(decimal))
  {
    let format = getConfig('format.percent');
    result = format.replace('{N}', decimal);
  }

  return result;
}

export function formatDate (value) {
  return _formatDate(value, getConfig('format.date'));
}

export function formatDateTime (value) {
  return _formatDate(value, getConfig('format.dateTime'));
}

export function formatTime (value) {
  return _formatDate(value, getConfig('format.time'));
}

export function formatNumber (value) {
  return _formatNumber(value);
}

export function formatDecimal (value) {
  return _formatDecimal(value);
}

export function formatCurrency (value) {
  return _formatCurrency(value);
}

export function formatPercent (value) {
  return _formatPercent(value);
}
